
































import { defineComponent, ref, computed } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'KECarousel',
  props: {
    itemsPerView: {
      type: Number,
      default: 1
    },
    showArrows: {
      type: Boolean,
      default: true
    }
  },
  setup(props, context) {
    const currentViewIndex = ref(0);

    const itemsCount = computed(() => {
      const slots = context.slots.default();
      return slots.length;
    });

    const totalViews = computed(() => {
      const itemsPerView = props.itemsPerView;
      return Math.ceil(itemsCount.value / itemsPerView);
    });

    const containerWidthPercentage = computed(() => {
      const itemsPerView = props.itemsPerView;
      const viewsCount = itemsCount.value / itemsPerView;
      return `${viewsCount * 100}%`;
    });

    const currentViewTranslationX = computed(() => {
      const itemsPerView = props.itemsPerView;
      const percentageTakenByOneItem = 100 / itemsCount.value;

      // max items we can shift without exposing empty space
      const maxOffsetItems = Math.max(itemsCount.value - itemsPerView, 0);

      // desired offset based on view index
      const desiredOffsetItems = currentViewIndex.value * itemsPerView;

      // clamp so the last step only skips remaining items
      const clampedOffsetItems = Math.min(desiredOffsetItems, maxOffsetItems);

      return `-${clampedOffsetItems * percentageTakenByOneItem}%`;
    });

    const isFirstView = computed(() => {
      return currentViewIndex.value === 0;
    });

    const isLastView = computed(() => {
      return currentViewIndex.value === totalViews.value - 1;
    });

    const handleMoveRight = () => {
      if (currentViewIndex.value < totalViews.value - 1) {
        currentViewIndex.value++;
      }
    };
    const handleMoveLeft = () => {
      if (currentViewIndex.value > 0) {
        currentViewIndex.value--;
      }
    };

    return {
      containerWidthPercentage,
      currentViewTranslationX,
      isFirstView,
      isLastView,
      itemsCount,
      handleMoveLeft,
      handleMoveRight
    };
  }
});
